import { render, staticRenderFns } from "./MlbTopPlayer.vue?vue&type=template&id=578a7204&scoped=true"
import script from "./MlbTopPlayer.vue?vue&type=script&lang=js"
export * from "./MlbTopPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a7204",
  null
  
)

export default component.exports